import { render, staticRenderFns } from "./TransferProductsUpdateModal.vue?vue&type=template&id=b15331b8&"
import script from "./TransferProductsUpdateModal.vue?vue&type=script&lang=js&"
export * from "./TransferProductsUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports